import axios, {AxiosRequestConfig, AxiosResponse} from 'axios';
import {getIdToken} from './auth-shared';

export const domainUrl = process.env.VUE_APP_BASE_API_URL;
// export const domainUrl = 'https://staging1b.takemobi.io/mobility-planner/demo';
export const baseURL = `${domainUrl}/v2/`;

const addIdToken = (options: AxiosRequestConfig = {}) => {
  const id = getIdToken();
  if (id) {
    options.headers = {
      ...(options.headers || {}),
      Authorization: `Bearer ${id}`,
    };
  }
  return options;
};

export const APIBaseService = {
  get<T>(path: string, options?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    const url = (options && options.baseURL) || baseURL;
    return axios.get<T>(`${url}${path}`, addIdToken(options));
  },
  delete<T>(path: string, options?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return axios.delete(`${baseURL}${path}`, addIdToken(options));
  },
  post<T>(path: string, data?: unknown, options?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return axios.post<T>(`${baseURL}${path}`, data, addIdToken(options));
  },
};
